/* RESPONSIBLE TEAM: team-proactive-support */

import BlockSerializer from './block';

export default BlockSerializer.extend();
